const initialState = () => ({
  sshPublicKeysList: [],
  sshPrivateKeysList: []
})

const state = initialState

const getters = {
  hostingSshPublicKeys: state => state.sshPublicKeysList,
  hostingSshPrivateKeys: state => state.sshPrivateKeysList
}

const mutations = {
  SET_HOSTING_PUBLIC_SSH_KEYS: (state, keys) => { state.sshPublicKeysList = keys },
  SET_HOSTING_PRIVATE_SSH_KEYS: (state, keys) => { state.sshPrivateKeysList = keys },
  CLEAR_HOSTING_SSH_STORE (state) {
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

const actions = {
  // get list of public ssh keys
  async loadHostingSshPublicKeysList ({ commit, dispatch }, _username) {
    const data = {
      api2_module: 'SSH',
      api2_method: 'listkeys',
      pub: 1,
      _username,
    }
    try {
      const response = await dispatch('cpanel_api2', data)
      commit('SET_HOSTING_PUBLIC_SSH_KEYS', response.payload.data)
    } catch (e) {
      throw e
    }
  },
  // get list of private ssh keys
  async loadHostingSshPrivateKeysList ({ commit, dispatch }, _username) {
    const data = {
      api2_module: 'SSH',
      api2_method: 'listkeys',
      pub: 0,
      _username,
    }
    try {
      const response = await dispatch('cpanel_api2', data)
      commit('SET_HOSTING_PRIVATE_SSH_KEYS', response.payload.data)
    } catch (e) {
      throw e
    }
  },
  // delete specified ssh key
  async deleteHostingSshKey ({ dispatch }, { name, pub, _username }) {
    const data = {
      api2_module: 'SSH',
      api2_method: 'delkey',
      pub,
      name,
      _username,
    }
    try {
      const response = await dispatch('cpanel_api2', data)
      return Promise.resolve(response.payload.data)
    } catch (e) {
      throw e
    }
  },
  // get an SSH key
  async getHostingSshKey ({ dispatch }, { name, pub, _username }) {
    const data = {
      api2_module: 'SSH',
      api2_method: 'fetchkey',
      pub,
      name,
      _username,
    }
    try {
      const response = await dispatch('cpanel_api2', data)
      return Promise.resolve(response.payload.data)
    } catch (e) {
      throw e
    }
  },
  // manage an SSH key
  async authHostingSshKey ({ dispatch }, { key, action, _username }) {
    const data = {
      api2_module: 'SSH',
      api2_method: 'authkey',
      key,
      action,
      _username
    }
    try {
      const response = await dispatch('cpanel_api2', data)
      return Promise.resolve(response.payload.data)
    } catch (e) {
      throw e
    }
  },
  // convert to PPK
  async convertToPpkHostingSshKey ({ dispatch }, { name, pass, keep_file = 1 }) {
    const data = {
      api2_module: 'SSH',
      api2_method: 'converttoppk',
      name,
      pass,
      keep_file
    }
    try {
      const response = await dispatch('cpanel_api2', data)
      return Promise.resolve(response.payload.data)
    } catch (e) {
      throw e
    }
  },
  // generate a new public key
  async generateHostingSshKey ({ dispatch }, { name, pass, bits, type, _username }) {
    const data = {
      api2_module: 'SSH',
      api2_method: 'genkey',
      name,
      pass,
      bits,
      type,
      _username,
    }
    try {
      const response = await dispatch('cpanel_api2', data)
      if (response.payload.error) {
        throw response.payload.error
      }
      return response.payload.data
    } catch (e) {
      throw e
    }
  },
  // import SSH key
  async importHostingSshKey ({ dispatch }, { name, pass, key, _username }) {
    const data = {
      api2_module: 'SSH',
      api2_method: 'importkey',
      name,
      pass,
      key,
      _username,
    }
    try {
      const response = await dispatch('cpanel_api2', data)
      if (response.payload.error) {
        throw response.payload.error
      }
      return response.payload.data
    } catch (e) {
      throw e
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
